<tec-spinner [show]="loading"></tec-spinner>
<main class="workspace" *ngIf="!loading">
    <header class="topnav">
        <div class="topnav__container">
            <div class="topnav__container__logo">
                <img alt="" src="assets/img/resources/tecalis.svg">
            </div>
            <div class="topnav__container__actions">
                <button class="button button--secondary">
                    {{ "AUDIT.DOWNLOAD_PDF" | translate }}
                </button>
                <button class="button">
                    {{ "AUDIT.DOWNLOAD_SIGNED_DOC" | translate }}
                </button>

            </div>
        </div>
            <!-- <div id="backdrop" class="topnav__container__backdrop"></div> -->
    </header>
    <div class="content">
        <div class="document">
            <div class="document__header">
                <div class="document__header__logo">
                    <img alt="" src="assets/img/resources/tecalis.svg">
                    <span>SIGN</span>
                </div>
                <div class="document__header__info">
                    <span>{{ "AUDIT.TITLE_RIGHT" | translate }}
                        <div class="tag tag--xs tag--warning" *ngIf="documentService.isPartialAudit(document)">{{ "AUDIT.PARTIAL" | translate}}</div>
                    </span>
                    <b>{{ document.operation_id | uppercase }}</b>
                </div>
            </div>
            <div class="document__body">
                <div class="document__body__sections">
                    <p>{{ "AUDIT.HEADER" | translate }}</p>
                    <div class="document-card">
                        <div class="grid grid-i2">
                            <div class="info-group info-group--horizontal">
                                <b for="">{{ "AUDIT.DOCUMENT" | translate }}</b>
                                <span>{{ document.file.name }}</span>
                            </div>
                            <div class="info-group info-group--horizontal">
                                <b for="">{{ "AUDIT.OPERATION_ID" | translate }}</b>
                                <span>{{ document.operation_id | uppercase }}</span>
                            </div>
                            <div class="info-group info-group--horizontal">
                                <b for="">{{ "AUDIT.SIGNATURE_TYPE" | translate }}</b>
                                <span>{{ "SIGNATURE_TYPE." + document.signature_type | translate }}</span>
                            </div>
                            <div class="info-group info-group--horizontal">
                                <b for="">{{ "AUDIT.DATETIME" | translate }}</b>
                                <span>{{ timeService.timestampToFormat(document.created_at) }} (UTC)</span>
                            </div>
                            <div class="info-group info-group--horizontal">
                                <b for="">{{ "AUDIT.CHECKSUM" | translate }}</b>
                                <span>{{ document.file.checksum ?? '-' }}</span>
                            </div>
                            <div class="info-group info-group--horizontal">
                                <b for="">{{ "AUDIT.VALIDATION_CODE" | translate }}</b>
                                <span>{{ code }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="document-tile">
                        <div class="document-tile__header">
                            <i class="icon-users"></i>
                            <span>{{ "AUDIT.ACTORS" | translate }}</span>
                        </div>
                        <div class="document-tile__body">
                            <table class="document-table">
                                <tbody>
                                <tr>
                                    <td>
                                        <div class="document-table__cell">
                                            <b>{{ "AUDIT.SENDER" | translate }}</b>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="document-table__cell">
                                            <span>{{ document.user.name }} {{ document.user.surname }}<span class="text--gray">({{ document.user.username }})</span></span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="document-table__cell">
                                            <b>{{ "AUDIT.RECEIVERS" | translate }}</b>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="document-table__cell">
                                            <p *ngFor="let receiver of documentService.getReceivers(document)">{{ receiver.name }} {{ receiver.surname }} <span class="text--gray">({{ receiver.email }})</span></p>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="document-banner" [ngClass]="{'document-banner--warning': documentService.isPartialAudit(document)}">
                        <i class="{{ document.status == documentService.STATUS_SIGNED ? 'icon-shield-check' : 'icon-clock'}}"></i>
                        <div class="document-banner__text">
                            <b>{{ documentService.statusText(document) | translate }}</b>
                            <span>{{ documentService.auditText(document) | translate }}</span>
                        </div>
                    </div>
                </div>
                <div class="document__body__sections border">
                    <div class="sections__title">{{ "AUDIT.SIGN_AND_EV" | translate }}</div>
                    <p>{{ "AUDIT.SIGN_AND_EV_TEXT" | translate }}</p>
                    <div class="document-item-wrapper">
                        <div id="open-filter" class="document-item" *ngFor="let receiver of document.receivers">
                            <div class="document-item__info">
                                <div class="tag-image tag-image--default">
                                    <i class="icon-signature"></i>
                                </div>
                                <div class="document-item__info__text">
                                    <b><ng-container *ngIf="document.signature_type !== Workflow.SIGNATURE_EMAIL_CERTIFICATE"></ng-container>{{ "SIGNATURE_TYPE." + document.signature_type | translate  }}</b>
                                    <span>{{ receiver.name }} {{ receiver.surname }} {{ !receiver.name ? receiver.email : '' }}</span>
                                </div>
                                <div class="tag tag--xs tag--success" *ngIf="receiver.status == documentService.STATUS_SIGNED">
                                    <i class="icon-verify"></i>
                                    <span>{{ 'AUDIT.VALID_SIGNATURE' | translate }}</span>
                                </div>
                            </div>
                            <div class="document-item__data" *ngIf="documentService.getSignedAt(receiver)">
                                <b>{{ timeService.timestampToFormat(documentService.getSignedAt(receiver), 'DD/MM/YYYY') }}</b>
                                <span>{{ timeService.timestampToFormat(documentService.getSignedAt(receiver), 'HH/mm/ss')  }} (UTC)</span>
                            </div>
                        </div>
                        <!--<div class="document-item">-->
                            <!--<div class="document-item__info">-->
                                <!--<div class="tag-image tag-image&#45;&#45;default">-->
                                    <!--<i class="icon-signature"></i>-->
                                <!--</div>-->
                                <!--<div class="document-item__info__text">-->
                                    <!--<b>Código por SMS</b>-->
                                    <!--<span>Verificación mediante código OTP SMS</span>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--<div class="document-item__data">-->
                                <!--<b>04/10/2024</b>-->
                                <!--<span>09:03:05 (UTC)</span>-->
                            <!--</div>-->
                        <!--</div>-->
                    </div>
                </div>
                <div class="document__body__sections">
                    <div class="sections__title">{{ 'AUDIT.HISTORIC' | translate }}</div>
                    <div class="document-item-wrapper">
                        <ng-container *ngFor="let receiver of document.receivers">
                            <ng-container  *ngFor="let evidence of receiver.evidences">
                                <app-evidence-list-item [evidence]="evidence" [receiver]="receiver"  (click)="loadEvidenceSidebar(evidence, receiver)"></app-evidence-list-item>
                            </ng-container>

                        </ng-container>

                        <!--<div class="document-item document-item&#45;&#45;historic">-->
                            <!--<div class="document-item__status">-->
                                <!--<div class="tag-image tag-image&#45;&#45;simple">-->
                                    <!--<i class="icon-send"></i>-->
                                <!--</div>-->
                                <!--<span>-->
                                            <!--Entregado-->
                                        <!--</span>-->
                            <!--</div>-->
                            <!--<div class="document-item__info">-->
                                <!--<div class="document-item__info__text">-->
                                    <!--<b>Correo electrónico enviado</b>-->
                                    <!--<span>carlos.bermudez@tecalis.com</span>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--<div class="document-item__data">-->
                                <!--<b>04/10/2024</b>-->
                                <!--<span>09:03:05 (UTC)</span>-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<div class="document-item document-item&#45;&#45;historic">-->
                            <!--<div class="document-item__status">-->
                                <!--<div class="tag-image tag-image&#45;&#45;simple">-->
                                    <!--<i class="icon-book-open"></i>-->
                                <!--</div>-->
                                <!--<span>-->
                                            <!--Abierto-->
                                        <!--</span>-->
                            <!--</div>-->
                            <!--<div class="document-item__info">-->
                                <!--<div class="document-item__info__text">-->
                                    <!--<b>Correo electrónico enviado</b>-->
                                    <!--<span>carlos.bermudez@tecalis.com</span>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--<div class="document-item__data">-->
                                <!--<b>04/10/2024</b>-->
                                <!--<span>09:03:05 (UTC)</span>-->
                            <!--</div>-->
                        <!--</div>-->
                    </div>
                </div>
                <div class="document__body__sections">
                    <div class="document-tile">
                        <div class="document-tile__body">
                            <div class="image-group-wrapper">
                                <div class="image-group">
                                    <div class="tag-image tag-image--simple">
                                        <i class="icon-legal"></i>
                                    </div>
                                    <div class="image-group__body">

                                        <h5>Legal</h5>
                                        <span>{{ "AUDIT.LEGAL_TEXT" | translate }}</span>
                                    </div>
                                </div>
                                <div class="image-group-divider"></div>
                                <div class="image-group">
                                    <div class="tag-image tag-image--simple">
                                        <i class="icon-lock"></i>
                                    </div>
                                    <div class="image-group__body">
                                        <h5>Secure</h5>
                                        <span>{{ "AUDIT.SECURE_TEXT" | translate }}</span>
                                    </div>
                                </div>
                                <div class="image-group-divider"></div>
                                <div class="image-group">
                                    <div class="tag-image tag-image--simple">
                                        <i class="icon-users"></i>
                                    </div>
                                    <div class="image-group__body">
                                        <h5>Trust</h5>
                                        <span>{{ "AUDIT.TRUST_TEXT" | translate }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br><br>
                <div class="document__body__stamps">
                    <img src="assets/img/resources/audit-seal.svg">
                    <img src="assets/img/resources/eidas.svg">
                </div>
            </div>


            <div class="document__footer">
                <div class="document__footer__info">
                    <img src="assets/img/resources/secure.svg">
                    <img src="assets/img/resources/fnmt.svg">
                    <span><b>Tecalis Software S.L.</b>| Rúa Oliveira 96B, 15895 Milladoiro (Ames), A Coruña, Spain</span>
                </div>
                <div class="document__footer__code">{{ document.operation_id }}</div>
                <!--<div class="document__footer__pagination">1/1</div>-->
            </div>



        </div>

        <div id="filter-sign" class="filters"  [ngClass]="{'filters--open': filters.sign}" *ngIf="filters.sign">
            <div class="filters__header">
                <h5 class="filters__header__title">Firmas y evidencias </h5>
                <div class="filters__header__actions">
                    <button class="button-icon" id="botonCerrar">
                        <i class="icon-close"></i>
                    </button>
                </div>
            </div>
            <div class="filters__body">
                <div class="info-group">
                    <b>Usuario</b>
                    <span>Isidoro Martínez Soñora (isidoro.martinez@tecalis.com)</span>
                </div>
                <div class="divider"></div>
                <div class="info-group">
                    <b>Fecha y hora</b>
                    <span>04/10/2021 - 09:03:04 (UTC)</span>
                </div>
                <div class="divider"></div>
                <div class="info-group">
                    <b>Tipo de firma</b>
                    <span>Firma con certificado con auditoría</span>
                    <div class="info-group__sign-container">
                        <svg width="111" height="90" viewBox="0 0 111 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.26343 54.1296C2.00134 50.7351 4.8829 44.3891 10.5611 44.3891C13.2176 44.3891 15.8741 44.3897 14.5459 49.2596M42.439 1C43.4721 1.88561 44.4756 7.73005 40.2253 24.0229C34.9123 44.3891 21.1871 80.6948 20.7443 83.7941C20.3016 86.8933 21.1871 93.9773 28.7138 83.7941C36.2405 73.6108 52.1795 47.9317 53.5077 46.1604C54.836 44.3891 58.3779 39.5192 59.7062 51.4734C61.0344 63.4276 65.4619 65.6414 70.7749 61.6566C76.0879 57.6719 80.9581 46.1604 79.6298 40.8474C78.3016 35.5344 69.4466 43.5039 72.9886 54.1296C75.5628 61.852 76.5306 61.2139 79.6298 58.5574C82.7291 55.9009 82.7291 54.1296 85.3856 54.1296C88.0421 54.1296 88.4848 58.5574 91.1413 58.5574C93.7978 58.5574 100.882 53.2444 103.538 55.9009C106.195 58.5574 106.195 61.6566 109.737 61.6566" stroke="#230243" stroke-width="1.77099" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>
                <div class="divider"></div>
                <div class="info-group">
                    <b>Firmado digitalmente por</b>
                    <span>FNMT-RCM</span>
                </div>
                <div class="divider"></div>
                <div class="info-group">
                    <b>Válido hasta</b>
                    <span>04/10/2021 - 09:03:04</span>
                </div>
                <div class="divider"></div>
            </div>
        </div>
        <div id="filter-historico" class="filters" [ngClass]="{'filters--open': filters.event}"  *ngIf="filters.event && filters.event_data.evidence">
            <app-evidence-sidebar
                    [document]="filters.event_data.document"
                    [receiver]="filters.event_data.receiver"
                    [evidence]="filters.event_data.evidence"
                    (close)="closeFilters()"
            ></app-evidence-sidebar>
        </div>
        <div id="backdrop" class="filters__backdrop" (click)="closeFilters()" [ngClass]="{'show': filters.event || filters.sign }"></div>
        <div class="floating-buttons">
            <button class="button-icon button-icon--circle">
                <i class="icon-chevron-up"></i>
            </button>
            <button class="button-icon button-icon--circle">
                <i class="icon-chevron-down"></i>
            </button>
            <button class="button-icon button-icon--circle">
                <i class="icon-zoom-in"></i>
            </button>
            <button class="button-icon button-icon--circle">
                <i class="icon-zoom-out"></i>
            </button>
        </div>
    </div>
</main>




